import { render, staticRenderFns } from "./TemplatesStatisticsEdit.vue?vue&type=template&id=13dea4f4"
import script from "./TemplatesStatisticsEdit.vue?vue&type=script&lang=js"
export * from "./TemplatesStatisticsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports